import { NLPHeader } from '../components/nlp/NLPHeader';
import { NLPHero } from '../components/nlp/NLPHero';
import { NLPTrustBar } from '../components/nlp/NLPTrustBar';
import { NLPBenefits } from '../components/nlp/NLPBenefits';
import { NLPImpact } from '../components/nlp/NLPImpact';
import { NLPFeatures } from '../components/nlp/NLPFeatures';
import { NLPFAQ } from '../components/nlp/NLPFAQ';
import { NLPCTA } from '../components/nlp/NLPCTA';
import { NLPFooter } from '../components/nlp/NLPFooter';

export function HomePageNLP() {
  return (
    <div className="min-h-screen bg-nlp-bg">
      <NLPHeader />
      <main>
        <NLPHero />
        <NLPTrustBar />
        <NLPBenefits />
        <NLPImpact />
        <NLPFeatures />
        <NLPFAQ />
        <NLPCTA />
      </main>
      <NLPFooter />
    </div>
  );
}
